import { gql } from '@apollo/client';

export const DELETE_FIND_IMAGE_MUTATION = gql`
  mutation DeleteFindImageMutation($findId: String!, $imageId: String!) {
    deleteFindImage(findId: $findId, imageId: $imageId) {
      ... on DeleteFindImageSuccess {
        find {
          id
          image
          images
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
